import { render } from "./RAGAdminDashboard.vue?vue&type=template&id=2d3b32da&scoped=true"
import script from "./RAGAdminDashboard.vue?vue&type=script&lang=js"
export * from "./RAGAdminDashboard.vue?vue&type=script&lang=js"

import "./RAGAdminDashboard.vue?vue&type=style&index=0&id=2d3b32da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3b32da"]])

export default __exports__